/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import { GlobalNavigationLineOfBusiness } from 'src/common/__generated__/api/types';
import { DatePicker, Typeahead } from 'src/components/common/modules/form';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { PrimaryButton, PrimaryButtonProps } from 'src/components/common/ui/button/button';

//helpers
import {
  formatDateWithLang,
  getLocalizationData,
  getWizardUrlOverrideURL,
  getWizOverrideDateParaName,
  linkTabOpenner,
  renderInvalidTypeheadStyles,
  getWizardDefaults,
  WizardDefaultProps,
  wizardDate,
  getDateFormatWithLang,
  getWizardsOverrides,
  getValidReturnDate,
} from '../../helpers';
import { UitkButtonSize } from 'uitk-react-button';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { useLocalization } from '@shared-ui/localization-context';
import { checkValue } from 'src/components/common/helper';
import { useStores } from 'src/utils/useStore';
import { sendSearchWizardSearchGTMEvent } from 'src/components/common/utils/gtmHelperFunctions';

export const PackagesUitk: React.FC<any> = ({ localizationData, device, data, mccidData }) => {
  const { context } = useStores();
  const { formatDateString } = useLocalization();
  const isHotelsCom = context?.site?.brand === 'hotels';

  const today = new Date();
  const dayAfterTwoWeeks = new Date();
  const nextDayAfterDayAfterTwoWeeks = new Date();
  dayAfterTwoWeeks.setDate(today.getDate() + 14);
  nextDayAfterDayAfterTwoWeeks.setDate(today.getDate() + 15);

  const searchURL = '/go/package/search/FlightHotel/';
  const searchedDateFormat = getDateFormatWithLang(context?.locale, 'yyyy-MM-dd');

  const urlParam = {
    adults: '1',
    cabinClass: 'e',
    destination: '',
    endDate: '',
    origin: '',
    startDate: '',
    cabinclass: '',
  };

  // Check the default data is coming from the searchOverride if so
  // Get the code
  const wizardDefault: WizardDefaultProps = {
    data,
    lob: 'Package',
    overrideController: 'returnDefault',
  };
  const wizardOverrideDefault = getWizardDefaults(wizardDefault);
  let returnDefault = '';
  if (checkValue(wizardOverrideDefault, true)) {
    const getReturn = wizardOverrideDefault?.find((w) => w.key === 'returnDefault');
    if (checkValue(getReturn) && checkValue(getReturn.value)) {
      returnDefault = getReturn?.value;
    }
  } else {
    returnDefault = get(data, 'returnDefault', '');
  }

  const wizardOverrides = getWizardsOverrides(data, 'Package');
  let wizardOverridesDepartureDate = '';
  let wizardOverridesReturnDate = '';
  if (checkValue(wizardOverrides, true)) {    
    wizardOverridesDepartureDate = wizardOverrides?.[0]?.dateFrom;
    wizardOverridesReturnDate = wizardOverrides?.[0]?.dateTo;        
}
  const departureDate = wizardDate(
    get(data, 'departureDate', ''),
    get(data, 'departureDateFixed', ''),
    wizardOverridesDepartureDate,
    dayAfterTwoWeeks,
    get(data, 'daysInFuture', ''),
    ''
  );
  const returnDatewizardDate = wizardDate(
    get(data, 'returnDate', ''),
    get(data, 'returnDateFixed', ''),
    wizardOverridesReturnDate,
    nextDayAfterDayAfterTwoWeeks,
    get(data, 'daysInFuture', ''),
    get(data, 'lengthOfStay', '')
  );
  const returnDate = getValidReturnDate(departureDate, returnDatewizardDate);

  //init state
  const initFormState = {
    leavingFrom: { value: get(data, 'departureDefault', ''), error: '', typeHeadId: 'packageleavingfrom' },
    goingTo: { value: returnDefault, error: '', typeHeadId: 'packagegoingTo' },
    departureDate: {
      value: departureDate,
      error: '',
    },
    returnDate: {
      value: returnDate,
      error: '',
    },
    isTravelersValid: true,
  };

  const [formState, setFormState] = useState(initFormState);

  const [isTravelerError, setIsTravelersError] = useState(false);

  //onChangeHandler
  const onChangeHandler = (state, value) => {
    setFormState((prev) => ({
      ...prev,
      [state]: {
        ...prev?.[state],
        value,
        error: '',
      },
    }));
  };

  //handle validations
  const handleValidations = () => {
    let isValidate = true;
    let fromError = '';
    let goingToError = '';

    if (formState?.leavingFrom?.value === '') {
      isValidate = false;
      fromError = getLocalizationData(localizationData, 'select_origin', 'Please select an origin', device);
    }

    if (formState?.goingTo?.value === '') {
      isValidate = false;
      goingToError = getLocalizationData(localizationData, 'select_destination', 'Please select a destination', device);
    }

    setFormState((prev) => ({
      ...prev,
      leavingFrom: { ...prev?.leavingFrom, error: fromError },
      goingTo: { ...prev?.goingTo, error: goingToError },
    }));

    return isValidate;
  };

  const updateTypeaheadFrom = (selectedValue) => {
    onChangeHandler('leavingFrom', selectedValue);
  };
  const updateTypeaheadTo = (selectedValue) => {
    onChangeHandler('goingTo', selectedValue);
  };
  const updateDates = (startDate, endDate) => {
    console.log(startDate, endDate);
  };

  const primaryButtonProps: PrimaryButtonProps = {
    text: getLocalizationData(localizationData, 'search_button_copy', 'Search', device),
    tag: 'button',
    gaTracking: {
      eventCategory: 'Button Click',
      eventAction: 'Featured Content',
      eventLabel: `${getLocalizationData(localizationData, 'search_button_copy', 'Search', device)} - ${'cTALink'}`,
    },
    exClass: `btn mobile-btn`,
    target: '_blank',
    size: UitkButtonSize.LARGE,
  };

  useEffect(() => {
    const errors = Object.keys(formState)
      .map((key) => ({
        error: get(formState, `[${key}].error`, ''),
        typeheadId: get(formState, `[${key}].typeHeadId`, ''),
      }))
      .filter(({ typeheadId }) => typeheadId !== '' && typeheadId !== false && typeheadId !== undefined);

    renderInvalidTypeheadStyles(errors);
  }, [formState]);

  const getPackagesOverWrides = (urlOverride, searchValue, replaceValue, valueSeparator) => {
    let separator = '';
    if (!urlOverride.includes('&')) separator = '&';
    return !urlOverride.includes(searchValue) ? `${separator}${searchValue}${valueSeparator}${replaceValue}` : '';
  };

  const generateURL = (urlParam, searchURL) => {
    searchURL = searchURL + urlParam.startDate + '/' + urlParam.endDate + '?';
    searchURL = searchURL + 'FromAirport=' + urlParam.origin + '&' + 'Destination=' + urlParam.destination + '&';   

    if (urlParam.children !== undefined) {
      if (
        !(
          urlParam.children &&
          Object.keys(urlParam.children).length === 0 &&
          Object.getPrototypeOf(urlParam.children) === Object.prototype
        )
      ) {
        searchURL =
          searchURL +
          Object.entries(urlParam.children)
            .map(([key, val]) => `${key}=${val}`)
            .join('&');
      }
    }
    if (urlParam.NumChild > 0) {
      searchURL = searchURL + '&NumChild=' + urlParam.NumChild;
    }
    searchURL = searchURL + '&cabinClass=' + urlParam.cabinClass + '&NumAdult=' + urlParam.adults + '&';
    searchURL = searchURL + 'ToTime=1200AM&NumRoom=1&NumAdult-Room1=1';
    
    return searchURL;
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!isTravelerError) {
      if (handleValidations()) {
        const tempobj = { ...urlParam };
        const childObj = {};
        const { elements } = event.currentTarget;
        let searchURLNew = '';
        const inputs = Array.from(elements) as HTMLInputElement[];
        // In this example, the inputs are just used to display a list of the user selections
        // setValues(inputs.map((input) => input.value));
        const childArray = inputs.filter((input) => {
          if (input.name.includes('EGDSSearchFormTravelersField-ChildrenAge-Room1-Child')) {
            return input;
          }
        });

        inputs.forEach((input) => {
          const inputVal: string = checkValue(input.value) ? input.value : '';

          if (input.name !== '') {
            if (input.name === 'EGDSSearchFormTravelersField-Adult-Room1') {
              tempobj.adults = inputVal;
            }
            if (input.name === 'EGDSSearchFormLocationField-Location-origin_select') {
              tempobj.origin = inputVal;
            }
            if (input.name === 'EGDSSearchFormLocationField-Location-destination_select') {
              tempobj.destination = inputVal;
            }
            if (input.name === 'cabin_class_input') {
              tempobj.cabinClass = inputVal;
            }
            if (input.name === 'EGDSDateRangePicker-EndDate-date_form_field') {
              tempobj.endDate = inputVal;
            }
            if (input.name === 'EGDSDateRangePicker-StartDate-date_form_field') {
              tempobj.startDate = inputVal;
            }
            return { ...tempobj };
          }
        });
        childArray.forEach((child, index) => {
          const childKEY = 'Child' + (index + 1) + 'Age';
          childObj[childKEY] = child.value;
          return { ...childObj };
        });
        
        if (isHotelsCom) {         
          const packageOverrideURL = getWizardUrlOverrideURL(
            'Package',
            'https://travel.hotels.com/Hotel-Search?packageType=fh&searchProduct=hotel',
            data?.wizardUrlOverride
          );
          searchURLNew =
            packageOverrideURL +
            '&adults=' +
            tempobj.adults +
            '&origin=' +
            getPackagesOverWrides(packageOverrideURL, 'origin', tempobj.origin, '=') +
            '&destination=' +
            getPackagesOverWrides(packageOverrideURL, 'destination', tempobj.destination, '=') +
            '&' +
            getWizOverrideDateParaName('Package', 'dateFrom', 'DATEFROM', 'startDate', data?.wizardUrlOverride) +
            '=' +
            formatDateWithLang(context?.locale, tempobj.startDate).date +
            '&' +
            getWizOverrideDateParaName('Package', 'dateTo', 'DATETO', 'endDate', data?.wizardUrlOverride) +
            '=' +
            formatDateWithLang(context?.locale, tempobj.endDate).date +
            '&sort=recommended&tripType=ROUND_TRIP';
        } else {         
          if (checkValue(data?.wizardUrlOverride, true)) {           
            const objURL = data?.wizardUrlOverride?.filter((item) => item.wizardTab === 'Package');
            if (checkValue(objURL?.[0])) {              
              const packageOverrideURL = getWizardUrlOverrideURL(
                'Package',
                '/go/package/search/FlightHotel/' +
                  formatDateString(tempobj.startDate, { raw: 'yyyy-MM-dd' }) +
                  '/' +
                  formatDateString(tempobj.endDate, { raw: 'yyyy-MM-dd' }) +
                  '?',
                data?.wizardUrlOverride
              );

              searchURLNew =
                packageOverrideURL
                  .replace('[From]', formatDateString(tempobj.startDate, { raw: 'yyyy-MM-dd' }))
                  .replace('[To]', formatDateString(tempobj.endDate, { raw: 'yyyy-MM-dd' })) 
                  .replace('[FROMAIRPORT]', tempobj.origin)
                  .replace('[TOAIRPORT]', tempobj.destination) +
                getPackagesOverWrides(packageOverrideURL, 'FromAirport', tempobj.origin, '=') +
                '&' +
                getPackagesOverWrides(packageOverrideURL, 'Destination', tempobj.destination, '=') +
                '&NumAdult=' +
                tempobj.adults +
                '&' +
                getWizOverrideDateParaName('Package', 'dateFrom', 'DATEFROM', 'startDate', data?.wizardUrlOverride) +
                '=' +
                formatDateWithLang(context?.locale, tempobj.startDate).date +
                '&' +
                getWizOverrideDateParaName('Package', 'dateTo', 'DATETO', 'endDate', data?.wizardUrlOverride) +
                '=' +
                formatDateWithLang(context?.locale, tempobj.endDate).date;
            } else {              
              const childs = childArray.length;
              searchURLNew = generateURL({ ...tempobj, children: childObj, NumChild: childs }, searchURL);              
            }
          } else {            
            const childs = childArray.length;
            searchURLNew = generateURL({ ...tempobj, children: childObj, NumChild: childs }, searchURL);            
          }
        }

        const searchParameters =
          tempobj.startDate + ' - ' + tempobj.endDate + '|' + tempobj.origin + ' - ' + tempobj.destination;

        sendSearchWizardSearchGTMEvent('wizard_search', 'Packages', searchParameters , searchURL);

        linkTabOpenner(searchURLNew, mccidData);
      }
    }
  };

  return (
    <>
      <div className="lodging-wrapper" data-testid="lodging-search-form">
        <form onSubmit={handleSubmit}>
          <UitkLayoutFlex space="six" alignItems="center" justifyContent="end">            
          </UitkLayoutFlex>
          <div className="grid">
            <UitkLayoutGrid className="wizard-row-top-margin">
              <UitkLayoutGridItem>
                <UitkLayoutGrid columns={{ small: 1, medium: 2, large: 3 }} space="three">
                  <UitkLayoutGridItem>
                    <Typeahead
                      controlid={formState?.leavingFrom?.typeHeadId}
                      label={getLocalizationData(localizationData, 'flying_from_label_copy', 'Flying From', device)}
                      icon={'place'}
                      name={'EGDSSearchFormLocationField-Location-origin_select'}
                      controller={'typeahead'}
                      updateModel={updateTypeaheadFrom}
                      placeholder={getLocalizationData(localizationData, 'flying_from_placeholder_copy', 'City or Airport', device)}
                      value={formState?.leavingFrom?.value}
                      hasClearButton={false}
                      lob={GlobalNavigationLineOfBusiness.FLIGHT}
                      error={formState?.leavingFrom?.error}
                    />
                  </UitkLayoutGridItem>
                  <UitkLayoutGridItem>
                    <Typeahead
                      controlid={formState?.goingTo?.typeHeadId}
                      label={getLocalizationData(localizationData, 'flying_to_label_copy', 'Flying to', device)}
                      icon={'place'}
                      name={'EGDSSearchFormLocationField-Location-destination_select'}
                      controller={'typeahead'}
                      updateModel={updateTypeaheadTo}
                      placeholder={getLocalizationData(localizationData, 'flying_to_placeholder_copy', 'City or Airport', device)}
                      value={formState?.goingTo?.value}
                      hasClearButton={false}
                      lob={GlobalNavigationLineOfBusiness.FLIGHT}
                      error={formState?.goingTo?.error}
                    />
                  </UitkLayoutGridItem>
                  <UitkLayoutGridItem>
                    <DatePicker
                      updateDates={updateDates}
                      startDate={formState?.departureDate?.value}
                      endDate={formState?.returnDate?.value}
                      startPlaceHolder={getLocalizationData(localizationData, 'departure_date_label_copy', 'Departure Date', device)}
                      endPlaceHolder={getLocalizationData(localizationData, 'return_date_label_copy', 'Return Date', device)}
                      startDateState={'packageStartDate'}
                      endDateState={'packageEndDate'}
                      singleMode={false}
                      doubleMonths={true}
                      dateFormat={searchedDateFormat}
                      selectCopy={getLocalizationData(localizationData, 'date_picker_select', 'Select Date', device)}
                      startLabel={getLocalizationData(localizationData, 'departure_date_label_copy', 'Departure Date', device)}
                      endLabel={getLocalizationData(localizationData, 'return_date_label_copy', 'Return Date', device)}
                      singleDateSelect={true}
                    />
                  </UitkLayoutGridItem>
                </UitkLayoutGrid>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem>
                <UitkLayoutGrid alignItems="center">
                  <UitkLayoutGridItem>
                    <div className="wizard-search-button-container">
                      <PrimaryButton {...primaryButtonProps} />
                    </div>
                  </UitkLayoutGridItem>
                </UitkLayoutGrid>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </div>
        </form>
      </div>
    </>
  );
};
